import React from 'react'

import isEmpty from 'utils/toolset/isEmpty'

import { useDragDropFileContext } from '../DragDropFile.context'
import { DragDropFileWrapper } from '../styles'
import type { WrapperProps } from '../types'

/**
 * This is a `Stack` component customized with the needed spacing between the DragDropFile inner components
 */
const Wrapper = ({ children, ...props }: WrapperProps) => {
  const { fileList } = useDragDropFileContext()

  return (
    <DragDropFileWrapper space="l" withFileList={!isEmpty(fileList)} {...props}>
      {children}
    </DragDropFileWrapper>
  )
}

export default Wrapper
